import buddy from './buddy'
import clip from './clip'
import dots from './dots'
import logo from './logo'
import shapes from './shapes'

// Reihenfolge im Dropdown
export const LAUNCHER_VARIANTS = [buddy, dots, logo, shapes, clip]
